@if (avoinna()) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" aria-modal="true" cdkTrapFocus [attr.aria-label]="'laskut.haku.modal-otsikko' | translate | async">
      <app-icon-button additionalClass="search-close" matIcon="close" [ariaLabel]="'laskut.haku.sulje' | translate | async" (click)="sulje()" actionId="Laskuhaku: sulje"></app-icon-button>

      <div class="search-content">
        <div class="search-field">
          <mat-form-field>
            <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
            <mat-label>{{ 'laskut.haku.hakukentan-placeholder' | translate | async }}</mat-label>
            <input type="text" matInput #hakukentta [formField]="hakuteksti" />
          </mat-form-field>
        </div>

        <div class="filters">
          <div class="dropdown-wrap">
            <div class="filter-btn-split" [class.filter-btn-active]="viimeiset12kkAktiivinen() || valittuAlkuPvm() || valittuLoppuPvm()">
              <app-button additionalClass="filter-btn-main" (click)="toggleViimeiset12kk()" actionId="Laskuhaku: viimeiset 12 kk">
                @if (viimeiset12kkAktiivinen()) {
                  {{ 'laskut.haku.aikavali-12kk-nimi' | translate | async }}
                } @else if (valittuAlkuPvm() || valittuLoppuPvm()) {
                  {{ aikavalinTeksti() }}
                } @else {
                  {{ 'laskut.haku.rajaa-aikavalia' | translate | async }}
                }
              </app-button>
              <app-icon-button additionalClass="filter-btn-caret" matIcon="expand_more" [ariaLabel]="'laskut.haku.avaa-aikavali-dropdown' | translate | async" (click)="vaihdaPaneeli('aikavali')" actionId="Laskuhaku: avaa aikaväli"></app-icon-button>
            </div>

            @if (avoinPaneeli() === 'aikavali') {
              <div class="dropdown aikavali-dropdown">
                <div class="date-fields">
                  <mat-form-field class="date-field">
                    <mat-label>{{ 'laskut.haku.alkaen' | translate | async }}</mat-label>
                    <input matInput [matDatepicker]="alkuPicker" [formField]="alkuPvm" (dateChange)="alkuPvmMuuttui()" />
                    <mat-datepicker-toggle matSuffix [for]="alkuPicker"></mat-datepicker-toggle>
                    <mat-datepicker #alkuPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field class="date-field">
                    <mat-label>{{ 'laskut.haku.asti' | translate | async }}</mat-label>
                    <input matInput [matDatepicker]="loppuPicker" [formField]="loppuPvm" (dateChange)="loppuPvmMuuttui()" />
                    <mat-datepicker-toggle matSuffix [for]="loppuPicker"></mat-datepicker-toggle>
                    <mat-datepicker #loppuPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="dropdown-actions">
                  <app-button additionalClass="dropdown-action" (click)="poistaAikavali()" actionId="Laskuhaku: tyhjennä aikaväli">
                    {{ 'laskut.haku.tyhjenna-valinnat' | translate | async }}
                  </app-button>
                  <app-button additionalClass="dropdown-action dropdown-action-primary" [disabled]="!valittuAlkuPvm() && !valittuLoppuPvm()" (click)="valitseAikavali()" actionId="Laskuhaku: valitse aikaväli">
                    {{ 'laskut.haku.valitse' | translate | async }}
                  </app-button>
                </div>
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <app-button additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': valitutTilat().length > 0 }" (click)="vaihdaPaneeli('tila')" actionId="Laskuhaku: avaa tila">
              {{ 'laskut.haku.suodatin-tila' | translate | async }}
              @if (valitutTilat().length > 0) {
                · {{ valitutTilat().length }}
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </app-button>

            @if (avoinPaneeli() === 'tila') {
              <div class="dropdown">
                @for (tila of kaikkiTilat(); track tila.tila) {
                  <div class="dropdown-item">
                    <mat-checkbox [checked]="onkoTilaValittu(tila.tila)" (change)="vaihdaTila(tila.tila)">{{ tila.nimi }}</mat-checkbox>
                  </div>
                }
                @if (valitutTilat().length > 0) {
                  <app-button additionalClass="dropdown-clear" (click)="tyhjennaTilat()" actionId="Laskuhaku: tyhjennä tilat">
                    {{ 'laskut.haku.tyhjenna-valinnat' | translate | async }}
                  </app-button>
                }
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <app-button additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': valitutAsiakkaat().length > 0 }" (click)="vaihdaPaneeli('asiakas')" actionId="Laskuhaku: avaa asiakas">
              {{ 'laskut.haku.suodatin-asiakas' | translate | async }}
              @if (valitutAsiakkaat().length > 0) {
                · {{ valitutAsiakkaat().length }}
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </app-button>

            @if (avoinPaneeli() === 'asiakas') {
              <div class="dropdown">
                <input type="text" class="dropdown-rajaus" [formField]="asiakasRajaus" [placeholder]="'laskut.haku.rajaa-listaa' | translate | async" [attr.aria-label]="'laskut.haku.rajaa-listaa' | translate | async" />
                @if (rajatutAsiakkaat().length === 0) {
                  <div class="dropdown-empty">{{ 'laskut.haku.ei-valintoja' | translate | async }}</div>
                }
                @for (asiakas of rajatutAsiakkaat(); track asiakas.avain) {
                  <div class="dropdown-item">
                    <mat-checkbox [checked]="onkoAsiakasValittu(asiakas.avain)" (change)="vaihdaAsiakas(asiakas.avain)">{{ asiakas.nimi }}</mat-checkbox>
                  </div>
                }
                @if (valitutAsiakkaat().length > 0) {
                  <app-button additionalClass="dropdown-clear" (click)="tyhjennaAsiakkaat()" actionId="Laskuhaku: tyhjennä asiakkaat">
                    {{ 'laskut.haku.tyhjenna-valinnat' | translate | async }}
                  </app-button>
                }
              </div>
            }
          </div>

          @if (naytaProjektitSuodatin()) {
            <div class="dropdown-wrap">
              <app-button additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': valitutProjektit().length > 0 }" (click)="vaihdaPaneeli('projekti')" actionId="Laskuhaku: avaa projekti">
                {{ 'laskut.haku.suodatin-projekti' | translate | async }}
                @if (valitutProjektit().length > 0) {
                  · {{ valitutProjektit().length }}
                }
                <mat-icon class="filter-caret">expand_more</mat-icon>
              </app-button>

              @if (avoinPaneeli() === 'projekti') {
                <div class="dropdown">
                  @for (projekti of kaikkiProjektit(); track projekti.avain) {
                    <div class="dropdown-item">
                      <mat-checkbox [checked]="onkoProjektiValittu(projekti.avain)" (change)="vaihdaProjekti(projekti.avain)">{{ projekti.nimi }}</mat-checkbox>
                    </div>
                  }
                  @if (valitutProjektit().length > 0) {
                    <app-button additionalClass="dropdown-clear" (click)="tyhjennaProjektit()" actionId="Laskuhaku: tyhjennä projektit">
                      {{ 'laskut.haku.tyhjenna-valinnat' | translate | async }}
                    </app-button>
                  }
                </div>
              }
            </div>
          }

          <span class="kasvata"></span>
          <div class="summien-verollisuus" role="group">
            <app-button additionalClass="summien-verollisuus-nappi" [dynamicClass]="{ valittu: !naytaSummatVerottomina() }" [ariaPressed]="!naytaSummatVerottomina()" (click)="naytaVerottomina(false)" actionId="Laskuhaku: summat sis. alv">{{ 'laskut.haku.summat-sis-alv' | translate | async }}</app-button>
            <app-button additionalClass="summien-verollisuus-nappi" [dynamicClass]="{ valittu: naytaSummatVerottomina() }" [ariaPressed]="naytaSummatVerottomina()" (click)="naytaVerottomina(true)" actionId="Laskuhaku: summat alv 0 %">{{ 'laskut.haku.summat-alv-0' | translate | async }}</app-button>
          </div>
        </div>

        @if (viimeiset12kkAktiivinen() || valitutTilat().length > 0 || valitutAsiakkaat().length > 0 || valitutProjektit().length > 0) {
          <div class="chips">
            @if (viimeiset12kkAktiivinen()) {
              <span class="filter-chip">
                {{ 'laskut.haku.aikavali-12kk-nimi' | translate | async }}
                <app-icon-button additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'laskut.haku.poista-suodatin' | translate | async" (click)="poistaAikavali()" actionId="Laskuhaku: poista aikaväli"></app-icon-button>
              </span>
            }
            @for (item of valitutTilatLista(); track item.tila) {
              <span class="filter-chip">
                {{ 'laskut.haku.suodatin-tila' | translate | async }} · {{ item.nimi }}
                <app-icon-button additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'laskut.haku.poista-suodatin' | translate | async" (click)="poistaTilaValinta(item.tila)" actionId="Laskuhaku: poista tila"></app-icon-button>
              </span>
            }
            @for (item of valitutAsiakkaatLista(); track item.avain) {
              <span class="filter-chip">
                {{ 'laskut.haku.suodatin-asiakas' | translate | async }} · {{ item.nimi }}
                <app-icon-button additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'laskut.haku.poista-suodatin' | translate | async" (click)="poistaAsiakasValinta(item.avain)" actionId="Laskuhaku: poista asiakas"></app-icon-button>
              </span>
            }
            @for (item of valitutProjektitLista(); track item.avain) {
              <span class="filter-chip">
                {{ 'laskut.haku.suodatin-projekti' | translate | async }} · {{ item.nimi }}
                <app-icon-button additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'laskut.haku.poista-suodatin' | translate | async" (click)="poistaProjektiValinta(item.avain)" actionId="Laskuhaku: poista projekti"></app-icon-button>
              </span>
            }
          </div>
        }

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'laskut.haku.haetaan' | translate | async }}</div>
          } @else if (!onkoHakuehtoja()) {
            <div class="hint">{{ 'laskut.haku.ohje-alkutila' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            <div class="hint">{{ 'laskut.haku.ei-tuloksia' | translate | async }}</div>
          } @else {
            <table class="tulokset-table">
              <thead>
                <tr>
                  <th class="col-tila">{{ 'laskut.tila' | translate | async }}</th>
                  <th class="col-nro">{{ 'laskut.numero' | translate | async }}</th>
                  <th class="col-asiakas">{{ 'laskut.asiakas' | translate | async }}</th>
                  <th class="col-pvm">{{ 'laskut.laskun-pvm' | translate | async }}</th>
                  <th class="col-pvm">{{ 'laskut.erapaiva' | translate | async }}</th>
                  <th class="col-summa">{{ 'laskut.summa' | translate | async }}</th>
                  <th class="col-summa">{{ 'laskut.avoinna' | translate | async }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of tulokset(); track row.avain) {
                  <tr tabindex="0" (click)="avaaLasku(row)" (keydown.enter)="avaaLasku(row)" (keydown.space)="$event.preventDefault(); avaaLasku(row)" [class.lemon-lapsi]="row.tyyppi === 'l'" [class.lemon-lapsi-viimeinen]="row.tyyppi === 'lv'" [class.lemon-vanhempi]="row.tyyppi === 'v'">
                    <td class="col-tila" [class.blue-text]="row.vari === 'blue'" [class.yellow-text]="row.vari === 'yellow'" [class.green-text]="row.vari === 'green'" [class.red-text]="row.vari === 'red'" [class.purple-text]="row.vari === 'purple'" [class.mint-text]="row.vari === 'mint'">
                      @if (row.tyyppi === 't' || row.tyyppi === 'v') {
                        <span class="tila-pilleri">{{ row.tilanKaannosavain | translate | async }}</span>
                      }
                    </td>
                    <td class="col-nro">{{ row.nro }}</td>
                    <td class="col-asiakas">{{ row.asiakas }}</td>
                    <td class="col-pvm">{{ row.pvm | lokaalipvm | async }}</td>
                    <td class="col-pvm">{{ row.erapvm | lokaalipvm | async }}</td>
                    <td class="col-summa">
                      @if (naytaSummatVerottomina()) {
                        @if (row.summaAlv0Euroina !== undefined) {
                          {{ row.summaAlv0Euroina | lmoney: 'EUR' | async }}
                          <div class="alkuperainen-summa">{{ row.summaAlv0 | lmoney: row.valuutta | async }}</div>
                        } @else {
                          {{ row.summaAlv0 | lmoney: row.valuutta | async }}
                        }
                      } @else if (row.summaEuroina !== undefined) {
                        {{ row.summaEuroina | lmoney: 'EUR' | async }}
                        <div class="alkuperainen-summa">{{ row.summa | lmoney: row.valuutta | async }}</div>
                      } @else {
                        {{ row.summa | lmoney: row.valuutta | async }}
                      }
                    </td>
                    <td class="col-summa">
                      @if ((row.tyyppi === 'v' || row.tyyppi === 't') && row.tila !== 'lu' && row.nrotyyppi !== 'h') {
                        @if (row.avoinnaEuroina !== undefined) {
                          {{ row.avoinnaEuroina | lmoney: 'EUR' | async }}
                          <div class="alkuperainen-summa">{{ row.avoinna | lmoney: row.valuutta | async }}</div>
                        } @else {
                          {{ row.avoinna | lmoney: row.valuutta | async }}
                        }
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <div class="tulokset-alareuna">
              {{ 'laskut.haku.osumia' | translate: { maara: kokonaismaara() } | async }}
              @if (naytaSummatVerottomina() && yhteissummaAlv0() !== null) {
                · {{ 'laskut.haku.yhteensa' | translate | async }} {{ yhteissummaAlv0() | lmoney: 'EUR' | async }} {{ 'laskut.haku.yhteissumma-alv-0' | translate | async }}
              } @else if (!naytaSummatVerottomina() && yhteissummaSisAlv() !== null) {
                · {{ 'laskut.haku.yhteensa' | translate | async }} {{ yhteissummaSisAlv() | lmoney: 'EUR' | async }} {{ 'laskut.haku.yhteissumma-sis-alv' | translate | async }}
              }
            </div>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu()" [pageSize]="sivunKoko()" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
